import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["resetBtn"]

  connect() {
    this.activeFilters = {
      rating: [],
      job: [],
      faction: []
    }
  }

  toggle(event) {
    const btn = event.currentTarget
    const type = btn.dataset.filterType
    const value = btn.dataset.filterValue

    const index = this.activeFilters[type].indexOf(value)
    if (index === -1) {
      this.activeFilters[type].push(value)
      btn.classList.add("filter-btn-active")
    } else {
      this.activeFilters[type].splice(index, 1)
      btn.classList.remove("filter-btn-active")
    }

    this.applyFilters()
    this.updateResetBtn()
  }

  applyFilters() {
    const cards = document.querySelectorAll(".partner-card-link")

    cards.forEach(card => {
      if (card.closest("[data-filter-ignore]")) return
      const p = card.querySelector(".partner-card")
      const job = p.dataset.job
      const rating = p.dataset.rating
      const faction = p.dataset.faction

      const jobMatch = this.activeFilters.job.length === 0 || this.activeFilters.job.includes(job)
      const ratingMatch = this.activeFilters.rating.length === 0 || this.activeFilters.rating.includes(rating)
      const factionMatch = this.activeFilters.faction.length === 0 || this.activeFilters.faction.includes(faction)

      card.style.display = jobMatch && ratingMatch && factionMatch ? "" : "none"
    })
  }

  reset() {
    this.activeFilters = { rating: [], job: [], faction: [] }
    document.querySelectorAll(".filter-btn-active").forEach(btn => btn.classList.remove("filter-btn-active"))
    this.applyFilters()
    this.updateResetBtn()
  }

  updateResetBtn() {
    const hasActive = Object.values(this.activeFilters).some(arr => arr.length > 0)
    if (this.hasResetBtnTarget) {
      this.resetBtnTarget.classList.toggle("filter-reset-active", hasActive)
    }
  }
}
